/** Classe usata da `ConfigurationCardSectionsMenu` per trovare lo slot. */
export const CONFIGURATION_CARD_MENU_SLOT_CLASS =
  'configuration-card-menu-slot';

/**
 * Slot vuoto per il menu delle sezioni, da passare come `extra` del Drawer:
 * `ConfigurationCardSectionsMenu` (montato dal `ConfigurationCardGroup` dentro
 * il body) vi proietta il bottone-menu via Portal. Nei Drawer senza slot il
 * menu semplicemente non compare.
 */
export function ConfigurationCardMenuSlot() {
  return <div className={CONFIGURATION_CARD_MENU_SLOT_CLASS} />;
}
